import React from "react";

/**
 * Generic row component
 *
 * @param {Object} props
 * @param {string?} props.id
 * @param {React.ReactNode} props.children
 * @returns {React.JSX.Element}
 */
export default function RowWrapper({ id, children }) {
  return (
    <div id={id} className="row">
      {children}
    </div>
  );
}
